import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getWinPercent=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_WIN_PERCENT_START
    })
    const options={
        url:`${api}/twoDWinPercent`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_WIN_PERCENT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_WIN_PERCENT_FAIL,
                payload:getMessage(error)
            }))
}